import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectssattva } from "../../../../data/projects/sattva/data";
import { projectsektaworld } from "../../../../data/projects/ekta/data";

export const EktaEden62 = () => {
  const {
    ektaeden62: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsektaworld;

  return (
    <>
      <Helmet>
        <title>Ekta Eden 62, Juhu, Mumbai | Luxury 4 BHK Residences</title>

        <meta
          name="description"
          content="Discover Ekta Eden 62 in Juhu, Mumbai – an exclusive luxury residential project offering premium 4 BHK apartments with world-class amenities. Experience elegance and comfort in the heart of Mumbai."
        />

        <meta
          name="keywords"
          content="Ekta Eden 62 Juhu, Ekta Eden 62 Mumbai, luxury apartments Juhu, 4 BHK flats Juhu, Ekta Eden 62 price, Ekta World Juhu, premium residences Mumbai, luxury homes Juhu, new projects Juhu Mumbai"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/ekta-eden-62-juhu-mumbai"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
